/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'

interface UiFromInnerProps {
    children: React.ReactNode | React.ReactNode[]
    className?: string
}

const UiFormStickyFooter = (props: UiFromInnerProps) => {
    return (
        <footer
            className={clsx(
                'UiFormStickyFooter sticky bottom-0 z-10 flex justify-end',
                'bg-white border-gray-200 text-gray-900',
                'dark:bg-gray-950 dark:border-gray-800 dark:text-gray-100',
                props.className
            )}
        >
            {props.children}
        </footer>
    )
}

export default UiFormStickyFooter
